document.addEventListener("DOMContentLoaded", function () {

    const CITIES = [
        "New York, NY", "Los Angeles, CA", "Chicago, IL", "Houston, TX", "Phoenix, AZ",
        "San Diego, CA", "Dallas, TX", "San Francisco, CA", "Austin, TX", "Nashville, TN",
        "Denver, CO", "Seattle, WA", "Boston, MA", "Miami, FL", "Atlanta, GA",
        "Portland, OR", "Scottsdale, AZ", "Santa Monica, CA", "Beverly Hills, CA",
        "Brooklyn, NY", "Aspen, CO", "Palm Beach, FL", "Newport Beach, CA",
        "Palo Alto, CA", "Sarasota, FL", "Charleston, SC", "San Antonio, TX",
        "Minneapolis, MN", "Charlotte, NC", "Raleigh, NC", "Tampa, FL",
        "Salt Lake City, UT", "Savannah, GA", "San Jose, CA", "Boca Raton, FL",
        "Las Vegas, NV", "Laguna Beach, CA", "Greenwich, CT",
        "Napa, CA", "Bethesda, MD", "Hoboken, NJ", "Alexandria, VA",
        "Pasadena, CA", "Carmel, CA", "Westport, CT", "Birmingham, AL",
        "Reno, NV", "Park City, UT", "Santa Barbara, CA", "Bozeman, MT",
        "Montauk, NY", "Key West, FL", "Sedona, AZ", "Jackson Hole, WY",
        "Malibu, CA", "La Jolla, CA", "Vail, CO", "Martha's Vineyard, MA",
        "Telluride, CO", "Coronado, CA", "Hilton Head, SC",
        "Nantucket, MA", "Palm Springs, CA", "Tribeca, NY",
        "SoHo, NY", "West Hollywood, CA", "Buckhead, GA"
    ];

    const popup = document.getElementById("salesPopup");
    const message = document.getElementById("saleMessage");
    const closeBtn = document.getElementById("popupClose");
    const viewerCount = document.getElementById("viewerCount");

    const VIEWER_MIN = 25;
    const VIEWER_MAX = 75;

    const MIN_INTERVAL = 120000;
    const MAX_INTERVAL = 300000;
    const DISPLAY_DURATION = 4500;

    let dismissed = false;

    function random(arr) {
        return arr[Math.floor(Math.random() * arr.length)];
    }

    /* Shuffle the cities deck and walk through it — guarantees no repeats
       until every city has been shown. Reshuffles when exhausted. */
    function shuffle(arr) {
        const copy = arr.slice();
        for (let i = copy.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copy[i], copy[j]] = [copy[j], copy[i]];
        }
        return copy;
    }

    let cityDeck = shuffle(CITIES);

    function nextCity() {
        if (cityDeck.length === 0) cityDeck = shuffle(CITIES);
        return cityDeck.pop();
    }

    function generateSale() {

        const city = nextCity();

        return `Someone from ${city} just bought <strong>The ARCHER Mask</strong>`;

    }

    function showPopup() {

        if (dismissed || !message || !popup) return;

        message.innerHTML = generateSale();

        popup.classList.add("show");

        setTimeout(() => {
            popup.classList.remove("show");
        }, DISPLAY_DURATION);

    }

    function randomDelay() {

        return MIN_INTERVAL + Math.random() * (MAX_INTERVAL - MIN_INTERVAL);

    }

    function schedule() {

        setTimeout(() => {
            showPopup();
            schedule();
        }, randomDelay());

    }

    closeBtn?.addEventListener("click", function () {

        dismissed = true;
        popup.style.display = "none";

    });


    /* viewer counter */

    let count = Math.floor(Math.random() * (VIEWER_MAX - VIEWER_MIN)) + VIEWER_MIN;

    viewerCount && (viewerCount.innerText = count);

    setInterval(() => {

        let drift = Math.floor(Math.random() * 7) - 3;

        count += drift;

        if (count < VIEWER_MIN) count = VIEWER_MIN;
        if (count > VIEWER_MAX) count = VIEWER_MAX;

        viewerCount && (viewerCount.innerText = count);

    }, 4000);


    /* start popup — first one fires in the first ~30s so a quickly-bouncing
       visitor still sees one social-proof signal. Subsequent cadence is slow. */

    const FIRST_POPUP_MIN = 15000;
    const FIRST_POPUP_MAX = 30000;
    const firstDelay = FIRST_POPUP_MIN + Math.random() * (FIRST_POPUP_MAX - FIRST_POPUP_MIN);

    setTimeout(() => {

        showPopup();
        schedule();

    }, firstDelay);

});